function modePart(): string {
	switch (import.meta.env.MODE) {
		case 'msw':
		case 'test':
			return '[msw]';
		case 'development':
			return '[dev]';
		default:
			return '';
	}
}

function slotPart(): string {
	const slot = import.meta.env.VITE_SAMLLA_SLOT as string | undefined;
	return slot ? `[${slot}]` : '';
}

export function getModePrefix(): string {
	const parts = [slotPart(), modePart()].filter(Boolean);
	return parts.length === 0 ? '' : parts.join(' ') + ' ';
}

export function setupTitlePrefix(): () => void {
	if (typeof document === 'undefined') return () => {};

	const prefix = getModePrefix();
	if (!prefix) return () => {};

	const ensurePrefix = () => {
		const current = document.title;
		if (current && !current.startsWith(prefix)) {
			document.title = prefix + current;
		}
	};

	ensurePrefix();

	const observer = new MutationObserver(ensurePrefix);
	observer.observe(document.head, {
		childList: true,
		characterData: true,
		subtree: true
	});

	return () => observer.disconnect();
}
